import React from 'react'
import PropTypes from 'prop-types'
import { Link, withRouter } from 'react-router-dom'
import queryString from 'querystring'
import ReCAPTCHA from 'react-google-recaptcha'

import { Input, Button, Icon } from 'loyal-react'
import yn from 'yn'

import OnDemandLiveRegion from 'on-demand-live-region'
import MediaQuery from 'react-responsive'

const formatName = (name) => {
  return name.split(' ')[0]
}

const showMsgError = (error) => {
  setTimeout(function () {
    const liveRegionDelayed = new OnDemandLiveRegion({
      delay: 300,
      level: 'assertive',
      parent: '#error-password'
    })
    liveRegionDelayed.say(error)
  }, 2000)
}
const PasswordBox = ({
  handleChange,
  handleBack,
  handleClearError,
  handleRecaptcha,
  allowRecaptcha,
  recaptchaRef,
  recaptchaToken,
  username,
  password,
  name,
  email,
  phone,
  statusCognito,
  isHidden,
  error,
  location: { search },
  labelInputPassword = 'senha',
  textButton = 'entrar',
  linkEsqueciSenha = 'ESQUECI MINHA SENHA'
}) => {
  const isValid = !!password && ((recaptchaToken && recaptchaToken !== '') || !allowRecaptcha)
  const queryParams = queryString.parse(search.substring(1))
  const userUnconfirmed = statusCognito === 'UNCONFIRMED'
  const userForceChangePass = statusCognito === 'FORCE_CHANGE_PASSWORD'

  let textLabelPassword = 'Agora digite a sua senha'
  let textMessageInputPassword = `Bem vindo ao ${process.env.RAZZLE_TITLE}!`
  if (userForceChangePass) {
    textMessageInputPassword =
      'É aqui que você põe a senha que enviamos por e-mail para garantirmos que tu és tu mesmo!'
  } else if (name == '*****') {
    textMessageInputPassword = 'Agora digite sua senha :)'
    textLabelPassword = ''
  } else if (name) {
    textMessageInputPassword = `Olá, ${formatName(name)}`
  }

  if (userUnconfirmed) {
    password = ''
  }
  if (userForceChangePass) {
    labelInputPassword = 'senha provisória'
    textButton = 'confirmar e continuar'
    linkEsqueciSenha = 'REENVIAR SENHA TEMPORÁRIA'
  }

  const handleKeyPress = (e, element) => {
    let inputIndex = element
    const inputOrder = [
      'password',
      'btnEntrar'
    ]
    let isDisabled = true

    while (isDisabled) {
      if (inputOrder[inputIndex] === 'btnEntrar') {
        isDisabled = false
      } else {
        let input = document.querySelector(`#${inputOrder[inputIndex]}`)
        if (input.getAttribute('disabled') === null || input.getAttribute('disabled') === undefined) {
          isDisabled = false
        } else {
          inputIndex++
        }
      }
    }

    // eslint-disable-next-line no-unused-expressions
    if (e.key === 'Enter') {
      if (inputIndex) {
        e.target.blur()
        document.querySelector(`#${inputOrder[inputIndex]}`) &&
          document.querySelector(`#${inputOrder[inputIndex]}`).focus()
      }
    }
  }

  return (
    <>
      <div id='box-password' className={`box-login row pb-4 ${isHidden && 'd-none'}`}>
        <div className='col-12 col-md-6 col-lg-4 mr-auto ml-auto py-3 px-1 radius bg-white border border-color-ui-3 pb-5 mb-5'>
          <div className='row'>
            <div className='col-6 col-md-12 px-3 mb-2'>
              <p className='txt-body-sm'>
                <MediaQuery maxWidth={489}>
                  <a id='image-link' href='#' onClick={handleBack} className='txt-body-sm d-block' aria-label='Voltar' role='button'>
                    <Icon className='icon icon_left_app' />
                  </a>
                </MediaQuery>
                <MediaQuery minWidth={490}>
                  <a href='#' onClick={handleBack} className='txt-body-sm d-block' aria-label='Voltar' role='button'>
                    <Icon className='icon icon_left_app' />
                  </a>
                </MediaQuery>
              </p>
            </div>
            <MediaQuery maxWidth={489}>
              <div className='col-6 px-3 mb-2 close-login'>
                <p className='txt-body-sm'>
                  <a href={`https://${process.env.RAZZLE_APP_TENANT_DOMAIN}`} className='txt-body-sm d-flex justify-content-end' aria-label='Fechar tela de login' role='button'>
                    <Icon className='icon icon_menu_app_close' />
                  </a>
                </p>
              </div>
            </MediaQuery>
            <div className='col-12 px-3'>
              <div className='row align-items-center h-100'>
                <div className='col'>
                  <h1 tabIndex='-1' className='h1 login-title txt-title-3 color-brand-1 txt-font-body'>
                    {userForceChangePass
                      ? 'Digite a senha provisória enviada para seu e-mail'
                      : process.env.RAZZLE_MESSAGE_PASSWORDBOX_TITLE ||
                        `Bem vindo ao ${process.env.RAZZLE_MESSAGE_NAME || process.env.RAZZLE_TITLE}!`}
                  </h1>
                  <h2 className='txt-body-sm color-ui-2 mt-1 txt-font-body mb-1'>
                    {process.env.RAZZLE_MESSAGE_PASSWORDBOX_SUBTITLE || 'agora digite a sua senha.'}
                  </h2>
                </div>
              </div>
            </div>
            {userUnconfirmed ? (
              <div className='col-12 px-3 pt-2'>
                <p className='txt-body-sm'>
                  Seu e-mail não foi confirmado.
                  <br /> Verifique em seu e-mail cadastrado o link de confirmação.
                  <br />
                  Caso queira solicitar o reenvio acesse o esqueci senha.
                </p>
              </div>
            ) : (
              [
                <div className='col-12 px-3'>
                  <div className='row'>
                    <Input
                      id='password'
                      type='password'
                      label={
                        yn(process.env.RAZZLE_MESSAGE_PASSWORDBOX_LABELINPUTPASSWORD) ? labelInputPassword : 'senha'
                      }
                      className={`col-12 col-md-12 mt-1 ${error && 'error'}`}
                      childrenClassName={`${error && 'error'}`}
                      name='password'
                      aria-describedby={error && 'error-password'}
                      value={password.trim()}
                      onChange={handleChange}
                      onFocus={handleClearError}
                      onKeyDown={(e) => {
                        e.keyCode === 13 && e.preventDefault()
                        handleKeyPress(e, 1)
                      }}
                    />
                    {error && (
                      <div id='error-password' className='message message-error'>
                        <small aria-hidden='true' className='txt-subtitle txt-font-body color-error'>
                          {error && showMsgError(error.message)}
                          {error && error.message}
                        </small>
                      </div>
                    )}
                  </div>
                </div>,
                allowRecaptcha && (
                  <div className='col-12 px-3 pt-2 d-flex justify-content-center'>
                    <div className='row'>
                      <Input id='recaptchaToken' name='recaptchaToken' type='hidden' value={recaptchaToken} />
                      <ReCAPTCHA
                        hl={'pt'}
                        ref={(e) => (recaptchaRef = e)}
                        sitekey={process.env.RAZZLE_RECAPTCHA_PUBLIC_KEY}
                        onChange={handleRecaptcha}
                      />
                    </div>
                  </div>
                ),
                <div className='col-12 col-md-12 txt-center mt-2 px-3'>
                  <Button id='btnEntrar' className='btn btn-sm btn-featured' text={textButton} type={'submit'} disabled={!isValid} />
                  <div className='hide-absolute' aria-live='assertive' role='status' aria-atomic='true'>
                    {userForceChangePass && !isValid && 'Por favor, a senha provisória enviada por e-mail'}
                  </div>
                </div>
              ]
            )}
            <div className='col-12 col-md-12 txt-center mt-2 px-3'>
              <div className='row align-items-center h-100'>
                <div className='col txt-center'>
                  <Link
                    className='btn btn-sm btn-featured'
                    to={{
                      pathname: '/forgot-password',
                      state: {
                        username,
                        email,
                        phone,
                        statusCognito
                      },
                      search: queryString.stringify(queryParams)
                    }}
                  >
                    {yn(process.env.RAZZLE_MESSAGE_PASSWORDBOX_LINKESQUECISENHA)
                      ? linkEsqueciSenha
                      : 'ESQUECI MINHA SENHA'}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

PasswordBox.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleClearError: PropTypes.func.isRequired,
  handleRecaptcha: PropTypes.func.isRequired,
  recaptchaToken: PropTypes.string,
  allowRecaptcha: PropTypes.bool,
  recaptchaRef: PropTypes.object,
  username: PropTypes.string,
  password: PropTypes.string,
  name: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  statusCognito: PropTypes.string,
  isHidden: PropTypes.bool,
  error: PropTypes.object,
  location: PropTypes.shape({
    search: PropTypes.string
  })
}

export default withRouter(PasswordBox)
